import React from 'react';
import { Columns3Cog, MoveLeft } from 'lucide-react';
import { AuthLayout } from 'components';

export default function NotFound() {

  return (
    <AuthLayout>
      <div className="bg-white rounded-xl shadow-2xl overflow-hidden w-full max-w-md">
        <div className="bg-blue-800 px-8 py-8 text-center">
          <div className="flex items-center justify-center gap-2 text-white">
            <Columns3Cog className="color-white" />
            <span className="text-lg font-semibold">SENBOOK SYSTEM</span>
          </div>
        </div>

        <div className="mt-4 py-4 flex items-center justify-center">
          <span className="font-large">
            404 | Not Found
          </span>
        </div>
        <div className="mb-4 p-4 flex items-center justify-center rounded-xl">
          <button onClick={() => window.location.href = "/"} className="text-blue-500 hover:underline font-medium flex items-center justify-center">
            <MoveLeft className="color-[#1e40af] mr-2" /> Về trang chủ
          </button>
        </div>

        <div className="px-8 py-4 bg-gray-50 text-center">
          <p className="text-xs text-gray-500">
            2025 © HRM Solutions
          </p>
        </div>
      </div>
    </AuthLayout>
  );
}